<template>
  <div class="products-listing-filters-sort">
    <ais-sort-by :items="sortOptions"
                 class="products-listing-filters-sort__content">
      <template v-slot="{ items, currentRefinement, refine }">
        <div v-for="item in items"
             :key="item.value"
             class="products-listing-filters-sort__input-wrapper">
          <input type="radio"
                 name="productsSort"
                 :id="item.value"
                 :value="item.value"
                 :checked="item.value === currentRefinement"
                 @input="refine(item.value)" />
          <label :for="item.value"
                 class="products-listing-filters-sort__radio radio big">
            {{ item.label }}
          </label>
        </div>
      </template>
    </ais-sort-by>
  </div>
</template>

<script>
  import ProductsListingSortMixin from '@/mixins/products/listing/productsListingSort'

  export default {
    name: 'ProductsListingFiltersSort',
    mixins: [ProductsListingSortMixin]
  }
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables';

  .products-listing-filters-sort {
    &__content {
      padding-top: 10px;
    }

    &__input-wrapper {
      padding: 14px 5px;
      &:not(:last-child) {
        border-bottom: 1px solid $border-line;
      }
    }

    &__radio {
      padding-left: 40px;
      text-transform: uppercase;
      font-family: 'MotivaSans Light';
      font-size: 1.5rem;
      font-weight: normal;
      cursor: pointer;

      &::before {
        border: 1px solid $color-black;
        width: 18px;
        height: 18px;
      }

      &::after {
        top: 1px;
        left: 4px;
        width: 12px;
        height: 12px;
      }
    }

    input:checked {
      & + .products-listing-filters-sort__radio {
        font-family: 'MotivaSans SemiBold';
      }
    }
  }
</style>
